<script setup>
// import SettingsTheme from '../components/SettingsTheme.vue'
// import SettingsCalendarSetup from '../components/SettingsCalendarSetup.vue';
// import SettingsCalendarSettings from "../components/SettingsCalendarSettings.vue";

import PasswordResetScreen from '../components/PasswordResetScreen.vue';
// SettingsTheme.loadTheme()
</script>

<template>
  <div class="password-reset">
    <div class="mx-auto max-w-6xl">
      <div class="flex flex-wrap justify-between" >
        <div class="w-4/12">
          <h1 class="separator-center mb-2 leading-normal text-2xl">Password Reset</h1>
        </div>
        <div class="w-4/12"><RouterLink class="btn btn-primary float-right" to="/">Back to Home</RouterLink></div>
      </div>
        
        
      </div>
      <PasswordResetScreen></PasswordResetScreen>

  </div>
</template>